import { useQueryClient } from "@tanstack/react-query";

import { usePatchUsersUserId } from "api/generated/users/users";

import { USER_WITH_DETAILS_QUERY_KEY } from "../../user/queries/useUserWithDetailsQuery";

export function useUpdateUserMutation() {
    const client = useQueryClient();

    return usePatchUsersUserId({
        mutation: {
            onSuccess: (_response, { userId }) => {
                client.invalidateQueries({
                    queryKey: [USER_WITH_DETAILS_QUERY_KEY, userId],
                });
            },
        },
    });
}
